<template>
  <div class="scene-details">
    <section class="scene-details-banner">
      <div class="banner-bg" ref="bannerBg"></div>
      <div class="banner-cont">
        <div class="container">
          <div class="topWarp">
            <div class="container">
              <div class="row">
                <div class="bread-box">
                  <p class="bread">
                    <router-link to="/">回车课堂</router-link>
                    <i>＞</i>
                    <router-link to="/scene/">学习路线</router-link>
                    <i>＞</i>  
                    <span>{{sceneData.name}}</span>
                  </p>
                </div>
              </div>
            </div>        
          </div>
          <div class="scene-title">
            <pre class="scene-name">{{sceneData.name}}</pre>
          </div>
          <div class="scene-cont">
            <!-- <div class="scene-img">
              <img :src="sceneData.imagePath" :alt="sceneData.name">
            </div> -->
            <div class="scene-text">
              <h4><img src="@/image/scene-details/icon-tit-01.png" alt=""><span>路线说明</span></h4>
              <pre>{{sceneData.desc}}</pre>
              <h4><img src="@/image/scene-details/icon-tit-02.png" alt=""><span>学前基础</span></h4>
              <pre v-if="sceneData.preBasic || sceneData.preBasicCourses">{{sceneData.preBasic}}<ul class="basics-couese-list" v-if="sceneData.preBasicCourses"><li v-for="(item,index) in sceneData.preBasicCourses" :key="index">《<span @click="toDetails(item)">{{item.courseName}}</span>》<i v-if="index+1 < sceneData.preBasicCourses.length" class="color:#818896;text-decoration:underline;">、</i></li></ul></pre>
              <h4><img src="@/image/scene-details/icon-tit-03.png" alt=""><span>真实收获</span></h4>
              <pre>{{sceneData.learningGains}}</pre>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="scene-details-course">
      <h1>主要课程</h1>
      <div class="container">
        <div class="course-list">
          <ul>
            <li v-for="(item,index) in courseList" :key="index" :ref="`courseList${index}`">
              <div class="index-tab" @click.stop="clickStop">第{{index + 1}}步</div>
              <div class="course-info-box">
                <p class="step-name">{{item.name}}</p>
                <div class="course-info" :class="{'course-info-unlock':!item.unlockFlag}">
                  <div class="info-cont">
                    <div class="info-cont-left">
                      <div class="course-title">
                        <i v-if="item.difficultyLevel">{{item.difficultyLevel}}</i>
                        <span>{{item.courseName}}</span>
                      </div>
                      <div class="target-box">
                        <div class="target-title">学习目标</div>
                        <pre class="target-text">{{item.learningGoal}}</pre>
                      </div>
                      <div class="barrier-box">
                        <div class="barrier-title">关卡</div>
                        <p class="barrier-text">共 {{item.barrierCount?item.barrierCount:0}} 关</p>
                      </div>
                    </div>
                    <div class="info-cont-right"  @click="toBarrier(item)">
                      <div class="course-mask" v-if="!item.unlockFlag">
                        <div class="mask-cont" v-if="index !== 0 && !(item.needHelpNum == 0 && item.unlockFlag)">
                          <img class="badge-img" :src="item.badgePath" alt="">
                          <div class="help-box" v-if="item.unlockFlag">
                            <span style="color: #fff;">助力好友</span>
                            <ul>
                              <li v-for="(items,indexs) in item.helperHeadImages" :key="indexs"><img :src="items" alt=""></li>
                            </ul>
                          </div>
                          <div class="unlock-btn" @click.stop="unlock(item,index)" v-else>解锁</div>
                        </div>
                      </div>
                      <div class="course-card">
                        <img :src="item.courseImg" alt="">
                      </div>
                      <div class="course-progress">
                        <div class="progress-box">
                          <div class="progress-bar" :class="{'complete-bar': item.learnStatus == 2}" :style="`width:${item.totalProgress || 0}%`"></div>
                        </div>
                        <div class="progress-num">
                          <span class="complete" v-if="item.learnStatus == 2">已完成</span>
                          <span class="learning" v-if="item.learnStatus == 1">已学习{{item.totalProgress}}%</span>
                          <span class="not-started" v-if="item.learnStatus == 0 || !item.learnStatus">未开始</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- <section class="scene-reward">
      <h1>学完可获得</h1>
      <div class="container">
        <div class="reward-cont">
          <div class="card-list">
            <div class="tool-box" v-if="isShowGadgets">
              <img class='tool-img' src="" alt="">
              <p>{{sceneData.name}}工具</p>
              <span>可在网站“工具库”中查看和使用</span>
            </div>
            <img class='icon-add' src="@/image/scene-details/icon-add.png" alt="" v-if="isShowGadgets">
            <div class="certificate-box" v-if="learnedFlag" ref="certificate">
              <img class="certificate-title" src="@/image/scene-details/certificate-title.png" alt="">
              <div class="certificate-user">
                <img class="user-photo" :src="userPhoto+'?'+Math.random()*5 + 1" crossorigin="anonymous" alt="">
                <img class="icon-red-line" src="@/image/scene-details/icon-photo-02.png" alt="">
              </div>
              <p>恭喜“{{userName}}”掌握“{{skillName}}”技能</p>
              <span>{{learnedDate}}</span>
            </div>
            <img src="@/image/scene-details/icon-unlock-zs.png" class="certificate-img-box" alt="" v-else>
          </div>
          <div class="save-btn" v-if="learnedFlag" @click="saveImg">保存卡片分享</div>
        </div>
      </div>
    </section> -->
    <div class="unlock-popup-mask" v-if="isShowPopup">
      <div class="unlock-popup">
        <i class="close-popup" @click="close"></i>
        <div class="unlock-popup-cont">
          <p>邀请{{popupData.userNum}}位好友，点亮勋章即可成功解锁</p>
          <img class="icon-badge" :src="popupData.badgePath" alt="">
          <span>助力好友</span>
          <ul class="user-list">
            <li v-for="(item,index) in popupData.userNum" :key="index"><img :src="popupData.userPhotoImg[index]" alt=""></li>
          </ul>
          <div class="invitation-btn" @click="invitation()">邀请</div>
          <div class="qrCode-box" v-if="isShowQrcode">
            <i class="close-popup" @click="closeQrcode"></i>
            <img :src="popupData.qrCode" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import("@/assets/style.css");
import { axios } from '@/../api/init'
import { zhugeTrack, isMobile } from "@/../public/public";
import { Message } from 'element-ui';
import html2canvas from "html2canvas"
export default {
  name: '',
  data() {
    return {
      sign:"",
      studentId:"",
      sceneId:"",
      subscribed: false, // 订阅状态
      isShowPopup: false,
      sceneData:{},
      courseList:[],
      userPhoto:"",
      userName:"",
      skillName:"", // 技能名称
      learnedDate:"", //获得证书时间
      learnedFlag:"", // 是否学完
      popupData:{
        userNum:'', // 需解锁人数
        badgePath:'', // 徽章
        userPhotoImg:[], // 头像
        qrCode:'', // 邀请二维码
      },
      isShowQrcode: false, // 分享二维码
      isShowGadgets: false, // 小工具
      noClick: true,
    }
  },
  mounted(){
    this.sceneId = this.$route.query.sceneId
    this.IsAlive()
    window.pageYOffset = 0;
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  },
  methods:{
    IsAlive(name) {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET",
      }).then((res) => {
        if (res.data.success) {
          let result = res.data.resultObject;
          let sign = this.getSign(); //解析cookie中的sign
          localStorage.setItem("sign", sign);
          localStorage.setItem("studentId", res.data.resultObject.id);
          this.sign = localStorage.getItem("sign");
          this.studentId = localStorage.getItem("studentId");
          this.getSceneData(name)
        } else {
          if(name == 'unlock'){
            let url = VUE_APP_BASE_PATH_PASSPORT + "/user/login?refer=" + encodeURIComponent(window.location.href)  + '&codeLogin=true'
            window.location.href = url
          }
          localStorage.removeItem("sign");
          localStorage.removeItem("studentId");
          this.getSceneData(name)
        }
      });
    },
    getCookie(name) {
      //读取cookie
      var arr = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      );
      if (arr != null) return unescape(arr[2]);
      return null;
    },
    // 获取sign
    getSign() {
      var cookie = this.getCookie("_uc_t_");
      if (cookie != null) {
        var arr = cookie.split(";");
        return arr[2];
      }
      return null;
    },
    // 获取学习路线详情内容
    async getSceneData(name){
      let params = {}
      if(this.studentId && this.sign){
        params = {
          studentId: this.studentId,
          sign: this.sign,
        }
      }
      let res = await axios({
        url:
          VUE_APP_BASE_PATH_ONLINE_APP + `/interactive-course/scene/${this.sceneId}`,
        method: "GET",
        params: params,
      });
      if(res.data.status === 200){
        if(res.data.result){
          this.sceneData = res.data.result
          this.subscribed = res.data.result.subscribed
          this.courseList = res.data.result.sceneSteps
          this.courseList.forEach(val => {
            val.helperHeadImages = val.helperHeadImages?val.helperHeadImages.split(','):[]
            val.name = val.name.substr(val.name.indexOf('：') + 1)
            switch(val.difficultyLevel){
              case 0:
                val.difficultyLevel = "科普"
                break;
              case 1:
                val.difficultyLevel = "入门"
                break;
              case 2:
                val.difficultyLevel = "进阶"
                break;
              case 3:
                val.difficultyLevel = "提高"
                break;
            }
            
          })
          this.skillName = res.data.result.skillName
          this.learnedFlag = res.data.result.learnedFlag
          this.learnedDate = res.data.result.learnedDate
          this.userPhoto = res.data.result.userHeadImage
          this.userName = res.data.result.userNickName
          this.$refs.bannerBg.style.backgroundImage = `url(${this.sceneData.imagePath})`
          this.$refs.bannerBg.style.backgroundRepeat = 'no-repeat'
          this.$refs.bannerBg.style.backgroundSize = 'cover'
          this.$refs.bannerBg.style.backgroundPosition = 'top center'
          if(sessionStorage.getItem('toBottom')){
            this.$nextTick(()=>{
              setTimeout(()=>{
                let num = res.data.result.sceneSteps ? res.data.result.sceneSteps.length : 0
                let scrollIntoViewOptions = {
                  behavior:'smooth'
                }
                this.$refs[`courseList${num - 1}`][0].scrollIntoView(scrollIntoViewOptions)
              },100)
            })
            sessionStorage.removeItem('toBottom')
          }else{
            if(!name){
              this.$nextTick(()=>{
                setTimeout(()=>{
                  window.scrollTo(0,0)
                },100)
              })
            }
          }
          zhugeTrack('Web_进入学习路线详情',{
            "学习路线名称": res.data.result.name,
            "学习路线学科": res.data.result.menuName
          })
        }
      }else{
        Message.closeAll()
        Message.warning(res.data.message)
      }
    },
    // 学前基础跳转课程详情
    toDetails(data){
      window.open(`/detail/${data.courseId}.html`)
    },
    clickStop(){

    },
    async toBarrier(data){
      if(data.unlockFlag){
        // 订阅学习路线
        if(!this.sceneId){
          Message.error("学习路线不存在")
          return
        }
        let res = await axios({
          url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/scene/" +this.sceneId,
          method: "POST",
          params:{
            studentId: this.studentId,
            sign: this.sign
          }
        });
        if(res.data.status === 200 || res.data.status === 403){
          if(res.data.status === 200){
            zhugeTrack("Web_学习路线详情-报名成功")
          }
          // 无需判断是否有详情页 且 进入详情页（2021年4月21日）
          window.open(`/detail/${data.courseId}.html?sceneStepsId=${data.id}`)

          // if(data.apply){
          //   window.location.href = `/barrier.html#/?courseId=${data.courseId}&sceneStepsId=${data.id}`
          // }else{
          //   // 判断是否有详情页
          //   if(data.detailFlag){
          //     window.open(`/detail/${data.courseId}.html?sceneStepsId=${data.id}`)
          //   }else{
          //     // 下单
          //     this.freeToStudy(data.id, data.courseId)
          //   }
          // }
          zhugeTrack("Web_学习路线详情-点击课程",{
            "课程名称": data.courseName,
            "课程ID": data.courseId,
            "学习路线名称": this.sceneData.name
          })
        }else{
          Message.error("学习路线订阅失败")
        }
      }
    },
    // 开始学习 （2021年4月21日 暂时不需要下单功能）
    freeToStudy(sceneStepsId, courseId){
      if(isMobile()){
        window.location.href = "/qrcode.html#/"
        return
      }
      
      if(!this.noClick){
        return
      }
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET"
      }).then(res => {
        if(res.data.success){
          if(this.noClick){
            this.noClick = false
            axios({
              url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/to-learn",
              method: "POST",
              headers: {
                'Content-Type':'application/json'
              },
              params:{sign: this.sign},
              data:{studentId:res.data.resultObject.id,courseId:courseId}
            }).then(res=>{
              let data = res.data
              if (data.status == 200) {
                if(isMobile()){
                  window.location.href = "/qrcode.html#/"
                  this.noClick = true
                }else{
                  setTimeout(function () {
                    let str = sceneStepsId ? '&sceneStepsId=' + sceneStepsId : ''
                    window.location.href = `/barrier.html#/?courseId=${courseId}${str}`
                    this.noClick = true
                  }, 1200);
                }
              } else {
                Message.error(data.message)
                this.noClick = true
              }
            })
          }
        }else{
          if(isMobile()){
            window.location.href = "/qrcode.html#/"
          }else{
            window.location.href = VUE_APP_BASE_PATH_PASSPORT + "/user/login?refer=" + encodeURIComponent(window.location.href) + '&codeLogin=true'          
          }
        }
      })
    },
    // 解锁-打开助力弹窗
    async unlock(data,index){
      if(isMobile()){
        window.location.href = '/qrcode.html#/'
        return
      }
      this.IsAlive('unlock')
      let i = 0
      try{
        this.courseList.forEach((val,k)=>{
          if(val.unlockFlag == false){
            i = k
            throw new Error("ending");
          }
        })
      }catch(e){
        if(e.message == "ending"){
          // log("结束了") ;
        }
      }
      if(i < index){
        Message.closeAll()
        Message.warning('请按顺序解锁步骤')
        return 
      }
      let params = { 
        sceneStepId: data.id,
        studentId: this.studentId,
        sign: this.sign
      }
      let res = await axios({
        url:
          VUE_APP_BASE_PATH_ONLINE_APP + `/interactive-course/scene/help`,
        method: "GET",
        params: params,
      });
      if(res.data.status === 200){
        let result = res.data.result
        this.isShowPopup = true
        this.popupData.userNum = result.needHelpNum
        this.popupData.badgePath = result.badgePath
        this.popupData.userPhotoImg = result.helperHeadImages?result.helperHeadImages.split(','):[]
        this.wxQRcode(result.id)
        zhugeTrack('Web_学习路线详情-点击解锁',{
          "学习路线名称": this.sceneData.name
        })
      }
    },
    // 微信小程序二维码
    async wxQRcode(id){
      let sceneData = `origin=sih&id=${id}`
      let params = {
        page: 'pages/index/index',
        scene: sceneData,
        sceneType: 'code'
      }
      let res = await axios({
        url: VUE_APP_BASE_PATH_WEIXIN + "/mini/qrcode/xcx/create",
        method: "POST",
        params: params
      })
      if(res.status == 200){
        if(res.data.result){
          this.popupData.qrCode = 'data:image/jpg;base64,'+res.data.result
        }else{
          this.popupData.qrCode = ''
        }
      }
    },
    // 邀请二维码
    invitation(){
      this.isShowQrcode = true
      zhugeTrack('Web_学习路线详情-点击邀请',{
        "学习路线名称": this.sceneData.name
      })
    },
    // 关闭弹窗
    close(){
      this.isShowPopup = false
      this.isShowQrcode = false
    },
    closeQrcode(){
      this.isShowQrcode = false
    },
    // 保存荣誉证书
    saveImg(){
      this.$nextTick(() => {
        let nowScrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
        const targetDom = this.$refs.certificate
        var width = targetDom.style.width
        var cloneDom = targetDom.cloneNode(true)
        cloneDom.style.position = 'absolute'
        cloneDom.style.top = '0px'
        cloneDom.style.zIndex = '-1'
        cloneDom.style.width = width
        document.body.appendChild(cloneDom)

        html2canvas(cloneDom,{
          allowTaint: false,
          useCORS: true,
        }).then(canvas => {
          window.pageYOffset = nowScrollTop
          document.documentElement.scrollTop = nowScrollTop
          document.body.scrollTop = nowScrollTop
          let dataURL = canvas.toDataURL("image/png");
          let a = document.createElement('a');
          let event = new MouseEvent('click')
          a.download = '荣誉证书' 
          a.href = dataURL;
          a.dispatchEvent(event)
          cloneDom.remove()
        });
      })
    }
  }
}
</script>

<style lang="less" scoped>
.scene-details{
  // banner
  .scene-details-banner{
    position: relative;
    .banner-bg{
      width: 100%;
      height: 350px;
      // background-image: url(../image/scene-details/scene-details-banner.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      position: absolute;
      top:0;
      left:0;
      z-index:0;
      overflow: hidden;
      &::before{
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
        background: rgba(0,0,0,.3);
        z-index:5;
      }
      &:after{
        content: "";
        width: 200%;
        height: 200%;
        position: absolute;
        top:-30%;
        left:-30%;
        background: inherit;
        -webkit-filter: blur(70px);
        -moz-filter: blur(70px);
        -ms-filter: blur(70px);
        filter: blur(70px);
        z-index: 3;
      }
    }
    
    .banner-cont{
      position: relative;
      z-index:1;
      .topWarp{
        padding-top: 30px;
        width: 100%;
        .bread-box{
          padding: 0 15px;
          .bread{
            font-size: 16px;
            color: #fff;
            i{
              display: inline-block;
              padding:0 10px;
            }
            a{
              color: #fff;
              &:hover{
                color: #25c48b;
                text-decoration: underline;
              }
            }
            .curr-title{
              font-size: 16px;
              color: #25c48b;
            }
          }
        }
      }

      .scene-title{
        text-align: center;
        padding: 30px 0 60px;
        pre{
          line-height: 45px;
          font-family: PingFangSC-Semibold;
          font-size: 32px;
          color: #ffffff;
          margin:0;
        }
      }

      .scene-cont{
        background: #fff;
        padding: 40px;
        box-sizing: border-box;
        background-color: #ffffff;
        box-shadow: 0px 14px 14px 0px #ecf1f8;
        border-radius: 4px;
        .scene-text{
          .scene-name{
            font-family: PingFangSC-Semibold;
            line-height: 30px;
            font-size: 22px;
            color: #2a3c60 !important;
            word-wrap: break-word;
            white-space: pre-wrap;
            word-break:break-all;
          }
          h4{
            line-height: 25px;
            margin-top: 32px;
            img{
              display: inline-block;
              width: 18px;
              height: 20px;
              vertical-align:middle;
            }
            span{
              font-family: PingFangSC-Semibold;
              margin-left: 10px;
              display: inline-block;
              font-size: 18px;
              color: #2a3c60;
              vertical-align:middle;
            }
          }
          h4:first-child{
            margin:0;
          }
          pre{
            line-height: 24px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #818896;
            margin:10px 0 0;
            word-wrap: break-word;
            white-space: pre-wrap;
            word-break:break-all;
          }
          .basics-couese-list{
            //  display: inline-block;
            li{
              display: inline-block;
              color: #e28b32;
              span{
                cursor: pointer;
                color: #e28b32;
                text-decoration: underline;
                &:hover{
                  color: #FFB66C;
                }
              }
              i{
                display: inline-block;
                color: #818896;
              }
            }
          }
        }
      }
      @media (max-width: 1199px) {
        .scene-cont{
          display: block !important;
        }
      }
      @media (max-width: 600px) {
        .scene-cont{
          padding: 15px !important;
        }
      }
    }
  }

  // 主要课程
  .scene-details-course{
    margin-top: 60px;
    h1{
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      line-height: 42px;
      color: #2a3c60;
      text-align: center;
    }
    .course-list{
      margin-top: 40px;
      background-color: #ffffff;
      box-shadow: 0px 14px 14px 0px #ecf1f8;
      border-radius: 6px;
      padding: 40px;
      >ul{
        padding-left: 124px;
        box-sizing: border-box;
        position: relative;
        &:after{
          content:"";
          display: block;
          position: absolute;
          width:1px;
          height: calc(100% - 50px);
          border-left: 1px dashed #E88F34;
          left: 92px;
          top: 20px;
          z-index:1;
        }
        >li{
          position: relative;
          margin-bottom: 40px;
          box-sizing: border-box;
          .course-info-box{
            // 步骤名称
            .step-name{
              font-size: 18px;
              color: #2a3c60;
              line-height: 25px;
            }
            // 课程信息
            .course-info{
              margin-top: 20px;
              box-sizing: border-box;
              background-color: #f8fafd;
              border-radius: 4px;
              border: solid 1px #eff3fa;
              position: relative;
              .info-cont{
                padding: 30px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                .info-cont-left{
                  flex: 1;
                  .course-title{
                    i{
                      width: 40px;
                      text-align: center;
                      line-height: 20px;
                      height: 20px;
                      display: inline-block;
                      vertical-align:middle;
                      background-color: #25c48b;
                      border-radius: 2px;
                      font-size: 13px;
                      color: #ffffff;
                      margin-right: 8px;
                    }
                    span{
                      font-size: 18px;
                      color: #2a3c60;
                      font-weight: 600;
                      line-height: 25px;
                      display: inline-block;
                      vertical-align:middle;
                    }
                  }
                  .target-box{
                    margin-top: 20px;
                    max-width: 100%;
                    .target-title{
                      font-size: 16px;
                      font-weight: 600;
                      color: #25c48b;
                    }
                    .target-text{
                      font-family: PingFangSC-Regular;
                      font-size: 14px;
                      color: #2a3c60;
                      line-height: 20px;
                      margin: 10px 0 0;
                      word-wrap: break-word;
                      white-space: pre-wrap;
                      word-break:break-all;
                    }
                  }
                  .barrier-box{
                    margin-top: 20px;
                    position: relative;
                    .barrier-title{
                      font-size: 16px;
                      font-weight: 600;
                      color: #25c48b;
                    }
                    .barrier-text{
                      margin-top: 10px;
                      font-family: PingFangSC-Regular;
                      font-size: 14px;
                      line-height: 20px;
                      color: #e88f34;
                    }
                  }
                }
                .info-cont-right{
                  width: 275px;
                  height: 209px;
                  margin-left: 20px;
                  cursor: pointer;
                  background-color: #ffffff;
                  border: solid 1px #eff3fa;
                  border-radius: 4px;
                  overflow: hidden;
                  position: relative;
                  .course-card{
                    height: 169px;
                    img{
                      width: 100%;
                      height: 100%;
                    }
                  }
                  .course-progress{
                    height: 40px;
                    padding-left: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .progress-box{
                      width: 150px;
                      height: 6px;
                      background-color: #cccfd5;
                      border-radius: 3px;
                      position: relative;
                      .progress-bar{
                        position: absolute;
                        left:0;
                        top:0;
                        width: 0;
                        height: 6px;
                        background-color: #e88f34;
                        border-radius: 3px;
                        z-index:1;
                      }
                      .complete-bar{
                        background-color: #25c48b;
                      }
                    }
                    .progress-num{
                      height: 20px;
                      span{
                        display: block;
                        line-height: 20px;
                        font-size: 14px;
                      }
                      // 已完成
                      .complete{
                        color:#25c48b;
                        position: relative;
                        margin-right: 50px;
                        &:after{
                          position: absolute;
                          top: 50%;
                          right: -24px;
                          margin-top: -7px;
                          width: 14px;
                          height: 14px;
                          display: block;
                          content:"";
                          background: url("../image/scene-details/icon-complete.png") no-repeat;
                          background-size: 100% 100%;
                        }
                      }
                      // 学习中
                      .learning{
                        width: 105px;
                        text-align: center;
                        color: #e88f34;
                        white-space: no-wrap !important;
                      }
                      // 未开始
                      .not-started{
                        color: #01a0e4;
                        position: relative;
                        margin-right: 50px;
                        &:after{
                          position: absolute;
                          top:50%;
                          right: -24px;
                          margin-top: -7.5px;
                          width: 12px;
                          height: 15px;
                          display: block;
                          content:"";
                          background: url("../image/scene-details/icon-not-started.png") no-repeat;
                          background-size: 100% 100%;
                        }
                      }
                    }
                  }

                  // 解锁
                  .course-mask{
                    position: absolute;
                    top:0;
                    left:0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,.6);
                    border-radius: 4px;
                    z-index:2;
                    .mask-cont{
                      position: absolute;
                      top:50%;
                      left:50%;
                      transform: translate(-50%,-50%);
                      width: 240px;
                      text-align: center;
                      .badge-img{
                        min-height: 100px;
                        max-height: 100px;
                        display: inline-block;
                      }
                      .help-box{
                        margin-top: 10px;
                        span{
                          font-family: PingFangSC-Regular;
                          font-size: 14px;
                          color: #2a3c60;
                          line-height: 20px;
                        }
                        ul{
                          margin-top: 10px;
                          display: flex;
                          justify-content: center;
                          li{
                            margin-right: 10px;
                            img{
                              width: 30px;
                              height: 30px;
                              border-radius: 50%;
                              background: red;
                              display: inline-block;
                            }
                          }
                          li:last-child{
                            margin:0;
                          }
                        }
                      }
                      .unlock-btn{
                        position: relative;
                        z-index:2;
                        margin: 30px auto 0;
                        width: 80px;
                        height: 30px;
                        line-height: 30px;
                        background: #E88F34;
                        border-radius: 4px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #ffffff;
                        cursor: pointer;
                        &:hover{
                          background: #FFB66C;
                        }
                      }
                    }
                  }
                }
              }
              @media (max-width:880px) {
                .info-cont{
                  display: block !important;
                  .info-cont-right{
                    margin: 30px auto 0 !important;
                    text-align: center;
                  }
                }
              }
              @media (max-width: 600px){
                .info-cont{
                  padding: 20px;
                }
              }
            }
            .course-info-unlock{
              cursor: default;
            }
          }

          // 左侧步数 和 icon
          .index-tab{
            position: absolute;
            left: -124px;
            top: 0px;
            width: 60px;
            height: 24px;
            background-color: #ebfaf4;
            border-radius: 12px;
            text-align: center;
            line-height: 24px;
            font-size: 15px;
            color: #25c48b;
            &:after{
              display:block;
              content:"";
              width: 24px;
              height: 24px;
              position: absolute;
              top: 0px;
              right: -44px;
              border-radius: 50%;
              background-color: #ffefe0;
              z-index:3;
            }
            &:before{
              display:block;
              content:"";
              position: absolute;
              right: -38px;
              top: 6px;
              width: 12px;
              height: 12px;
              background-color: #e88f34;
              border-radius: 50%;
              z-index:4;
            }
          }
        }
        li:last-child{
          margin-bottom:0;
          position: relative;
          &:after{
            content:"";
            display:block;
            background: #fff;
            z-index:2;
            width: 15px;
            height: calc(100% - 42px);
            position: absolute;
            top: 24px;
            left: -38px;
          }
        }
      }
    }
    @media (max-width: 880px) {
      .course-list{
        padding: 25px;
      }
    }
    @media (max-width: 600px) {
      .course-list{
        padding: 10px !important;
        ul{
          padding:0;
          &:after{
            display: none;
          }
          li{
            margin-bottom: 20px;
            .index-tab{
              display: none;
            }
            .course-info{
              .info-top{
                padding: 20px 10px;
              }
              .info-cont{
                padding: 20px 10px;
              }
            }
            &:after{
              display: none !important;
            }
          }
        }
      }
    }
  }

  // 学完可获得
  .scene-reward{
    padding-bottom: 90px;
    margin-top: 80px;
    h1{
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      line-height: 42px;
      color: #2a3c60;
      text-align: center;
    }
    .reward-cont{
      margin-top: 40px;
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 14px 14px 0px #ecf1f8;
      padding: 50px 0;
      .card-list{
        display: flex;
        justify-content: center;
        align-items: center;
        // 工具卡片
        .tool-box{
          width: 270px;
          height: 320px;
          background-color: #ffffff;
          box-shadow: 0px 10px 28px 0px rgba(201, 201, 201, 0.51);
          border-radius: 4px;
          padding-top: 63px;
          .tool-img{
            display: block;
            width: 110px;
            height: 110px;
            margin: 0 auto;
            background: orange;
          }
          p{
            margin-top: 32px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 18px;
            line-height: 25px;
            color: #2a3c60;
          }
          span{
            display: block;
            margin-top: 20px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 20px;
            color: #818896;
          }
        }
        .certificate-box{
          margin-top:0;
          box-shadow: 0px 10px 28px 0px rgba(201, 201, 201, 0.51);
          padding-top: 22px;
        }
        // 未解锁的证书卡片
        .certificate-img-box{
          display: block;
          width: 270px;
          height: 320px;
          box-shadow: 0px 10px 28px 0px rgba(201, 201, 201, 0.51);
        }
        .icon-add{
          width: 25px;
          height: 25px;
          margin: 0 30px;
        }
      }
      .save-btn{
        margin: 50px auto 0;
        width: 150px;
        height: 54px;
        background-color: #25c48b;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #ffffff;
        line-height: 54px;
        text-align: center;
        cursor: pointer;
        &:hover{
          background-color: #28D899;
        }
      }
    }
  }
}

// 助力弹框
.unlock-popup-mask{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.4);
  position: fixed;
  top:0;
  left: 0;
  z-index:10;
  .unlock-popup{
    width: 360px;
    background: #fff;
    border-radius: 6px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    padding: 30px;
    .close-popup{
      cursor: pointer;
      position: absolute;
      top: 12px;
      right: 12px;
      width: 24px;
      height: 24px;
      background: url(../image/icon-close.png) no-repeat;
      background-size: 14px 13px;
      background-position: center;
    }
    .unlock-popup-cont{
      text-align: center;
      p{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 22px;
        color: #2a3c60;
      }
      .icon-badge{
        margin-top: 22px;
        height: 100px;
      }
      span{
        display: block;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #2a3c60;
        margin-top: 10px;
      }
      .user-list{
        margin-top: 10px;
        display: flex;
        justify-content: center;
        li{
          width: 30px;
          height: 30px;
          background-color: #e1e1e1;
          border-radius: 50%;
          margin: 0 5px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .invitation-btn{
        margin: 30px auto 0;
        width: 90px;
        height: 36px;
        line-height: 36px;
        background: #E88F34;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        &:hover{
          background: #FFB66C;
        }
      }
    }

    .qrCode-box{
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 150px;
      height: 170px;
      padding: 30px 10px 10px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0px 10px 28px 0px rgba(201, 201, 201, 0.51);
      .close-popup{
        top: 5px;
        right: 5px;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}


@media (max-width:1199px) {
  .container{
    max-width: 100% !important;
  }
}
</style>
<style lang="less">
// 证书卡片
.certificate-box{
  width: 270px;
  height: 320px;
  background: #ffffff;
  border-radius: 4px;
  padding-top: 22px;
  text-align: center;
  .certificate-title{
    height: 16px;
    margin-bottom: 6px;
  }
  .certificate-user{
    width: 194px;
    height: 85px;
    margin: 36px auto 0;
    position: relative;
    background: url(../image/scene-details/icon-photo-01.png) no-repeat;
    background-size: 194px 71px;
    background-position: top left;
    .user-photo{
      position: absolute;
      z-index:1;
      width: 62px;
      height: 62px;
      top: 5px;
      left: 66px;
      border-radius: 50%;
    }
    .icon-red-line{
      position: absolute;
      z-index:2;
      width: 137px;
      height: 29px;
      top: 55px;
      left: 50%;
      margin-left: -68.5px;
    }
  }
  p{
    margin-top: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 21px;
    color: #030320;
    padding: 0 40px;
  }
  span{
    display: block;
    // text-align: center;
    margin-top: 10px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 21px;
    color: #919191;
  }
}
</style>